module.exports = __webpack_public_path__ + "static/media/icon_Survey_W.8b390ef9.svg";